module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/line-554ea135d3d478b60e4d9e06a9f4acf2.svg";